import { PipelineStageEnum } from 'api-types';

export const PIPELINE_STAGE_TO_USER_STRINGS: {
  [key in PipelineStageEnum]: string;
} = {
  [PipelineStageEnum.ArkaRecommended]: 'Arka Recommended',
  [PipelineStageEnum.InternalDraft]: 'Internal Draft',
  [PipelineStageEnum.OutreachInitialized]: 'Stage 1',
  [PipelineStageEnum.OutreachCompleted]: 'Outreach completed',
  [PipelineStageEnum.Rejected]: 'Rejected',
  [PipelineStageEnum.AIInterviewCompleted]: 'AI Interview Completed',
  [PipelineStageEnum.Shortlist]: 'Shortlisted',
  [PipelineStageEnum.Starred]: 'Starred',
  [PipelineStageEnum.AIInterviewInitialized]: 'AI Interview Initialized',
};
